'use strict';

/**
 * Listing of the species in edit/create dialog
 *
 * @category   View
 * @module     collectio.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var CollectionView = require('base/Colido.CollectionView');
var SpeciesSelectionListItemView = require('./field-species-list-item');

var SpeciesSelectionListView = CollectionView.extend({
    childView: SpeciesSelectionListItemView,
});

module.exports = SpeciesSelectionListView;